import { COLORS } from "@/common/constants";
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter } from "@chakra-ui/react"

export type ConfirmationProps = {
    isOpen: boolean,
    onClose: () => void,
    title: string,
    handleCancel: () => void,
    handleConfirm: () => void,
    confirmationText: string,
    confirmButtonText?: string,
    cancelButtonText?: string,
    // confirmButtonText and cancelButtonText will be empty if given empty string
};

const ModalConfirmation = ({ isOpen, onClose, title, handleCancel, handleConfirm, confirmationText, confirmButtonText, cancelButtonText }: ConfirmationProps) => {
    const DEFAULT_CONFIRM_TEXT = "Confirm";
    const DEFAULT_CANCEL_TEXT = "Cancel";
    
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent borderRadius={15} padding={5}>
                <ModalHeader textAlign='center'>{title}</ModalHeader>
                <ModalCloseButton onClick={handleCancel} _focus={{ outline: 'none', boxShadow: 'none' }} />
                <ModalBody textAlign='center' marginTop={-5}>
                    {confirmationText}
                </ModalBody>
                <ModalFooter style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: 10 }}>
                    <Button onClick={handleCancel} borderColor='#D0D5DD' bgColor='white'>{cancelButtonText ?? DEFAULT_CANCEL_TEXT}</Button>
                    <Button onClick={handleConfirm} bgColor={COLORS.BUTTON.BACKGROUND} color={COLORS.BUTTON.FOREGROUND}>{confirmButtonText ?? DEFAULT_CONFIRM_TEXT}</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalConfirmation;